import React from 'react';
import { FaRegFilePdf } from 'react-icons/fa6';

const publications = [
  {
    id: 1,
    series: 'QLAB WORKING PAPER SERIES',
    title: 'Signal Discovery in Non-Stationary Markets',
    type: 'Working Paper 001',
    date: 'March 2026',
    abstract:
      'A framework for identifying persistent statistical signals in regime-shifting markets.',
  },
  {
    id: 2,
    series: 'QLAB WORKING PAPER SERIES',
    title: 'Adaptive Execution Models for Crypto Markets',
    type: 'Research Note 002',
    date: 'February 2026',
    abstract:
      'A microstructure-aware execution model designed to reduce slippage across fragmented liquidity venues.',
  },
  {
    id: 3,
    series: 'QLAB WORKING PAPER SERIES',
    title: 'Compression Regimes and Breakout Probability',
    type: 'Technical Paper 003',
    date: 'November 2025',
    abstract:
      'Probabilistic modeling of volatility compression states and subsequent breakout behavior.',
  },
];

const ResearchPublications = () => {
  return (
    <section className='bg-white px-5 pb-32 pt-20 md:px-8 lg:pb-36 lg:pt-24 xl:pb-40 xl:pt-28'>
      <div className='mx-auto w-full max-w-[1100px]'>
        <hr className='mb-12 border-0 h-[1px] bg-[#eeeeee]' />
        <h2 className='metro-semi mb-4 mt-2 text-[34px] text-primary-dark'>Research Publications</h2>
        <p className='mb-12 max-w-3xl text-[15px] leading-relaxed text-secondary-light md:text-[16px]'>
          Selected working papers and technical notes from the QLab institutional research program.
        </p>

        <div className='max-w-[900px]'>
          {publications.map((paper) => (
            <article
              key={paper.id}
              className='group flex items-start justify-between gap-6 border-b border-[#10121614] py-7'
            >
              <div className='min-w-0'>
                <p className='metro-semi text-[11px] uppercase tracking-[0.18em] text-[#8a8a8a]'>{paper.series}</p>
                <h3 className='metro mt-2 text-[24px] font-semibold leading-snug text-[#111111]'>{paper.title}</h3>
                <p className='metro mt-2 text-[13px] text-[#888888]'>
                  {paper.type} — {paper.date}
                </p>
                <p className='metro mt-3 max-w-[760px] text-[14px] leading-relaxed text-[#555555]'>
                  {paper.abstract}
                </p>
              </div>
              <button
                type='button'
                className='metro mt-1 inline-flex shrink-0 items-center gap-2 text-[13px] text-primary-dark transition-opacity duration-200 group-hover:opacity-80'
              >
                Download PDF
                <FaRegFilePdf className='text-[14px]' aria-hidden='true' />
              </button>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ResearchPublications;
